import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { FedevAuthService } from '@bmw-fedev/auth';

const WRITE_AUTH_ENDPOINTS: readonly string[] = ['/api/translations'];

const needsWriteAuth = (url: string): boolean =>
  WRITE_AUTH_ENDPOINTS.some((endpoint) => url.endsWith(endpoint));

export const writeAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (req.method === 'GET' || !needsWriteAuth(req.url)) {
    return next(req);
  }

  const token = inject(FedevAuthService).accessToken;
  if (!token) {
    return next(req);
  }

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
